import React, {
  createContext,
  useContext,
  ReactNode,
  useState,
  useCallback,
} from "react";

export type Token = string | null;

interface LoginContextType {
  token: Token;
  setToken: (token: string | null) => void;
}

const LoginContext = createContext<LoginContextType | undefined>(undefined);

export const useLoginContext = () => {
  const context = useContext(LoginContext);
  if (!context) {
    throw new Error("useLogin must be used within a LoginProvider");
  }
  return context;
};

interface LoginProviderProps {
  children: ReactNode;
}

export const LoginProvider: React.FC<LoginProviderProps> = ({ children }) => {
  const [token, setToken] = useState<Token>(localStorage.getItem("jwt-token"));

  const setTokenState = useCallback((newToken: string | null) => {
    setToken(newToken);
    if (newToken) {
      localStorage.setItem("jwt-token", newToken);
    } else {
      localStorage.removeItem("jwt-token");
    }
  }, []);

  return (
    <LoginContext.Provider value={{ token, setToken: setTokenState }}>
      {children}
    </LoginContext.Provider>
  );
};
